import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";

interface Stat {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  description?: string;
}

interface StatsBarProps {
  stats: Stat[];
  isLoading?: boolean;
}

const StatsBar = ({ stats, isLoading }: StatsBarProps) => {
  // Dynamic grid columns based on stat count
  const gridCols = stats.length === 6 
    ? "grid-cols-2 md:grid-cols-3 lg:grid-cols-6" 
    : "grid-cols-2 md:grid-cols-4";
    
  return (
    <div className="border-y border-border bg-card/30 backdrop-blur-sm">
      <div className={`grid ${gridCols} divide-x divide-border`}>
        {stats.map((stat, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-center py-6 px-4 space-y-2"
          >
            <div className="text-godyspo-gold">{stat.icon}</div>
            <div className="text-3xl font-bold text-foreground">
              {isLoading ? (
                <Skeleton className="h-9 w-16 mx-auto" />
              ) : (
                stat.value
              )}
            </div>
            <div className="text-sm text-muted-foreground text-center">
              {stat.title}
            </div>
            {stat.description && (
              <div className="text-xs text-muted-foreground/70 text-center">
                {stat.description}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsBar;
